<template>
  <div class="browse">
    <div class="row">
      <img src="images/Ministries-open-for-recruitment-header.jpg" width="100%" />
      <div class='home-ddl-bar'>
          <select class='home-ddl' v-model='deptSelection' @change="getMinistryRoles">
              <option disabled selected value='default'>Type of Ministry</option>
              <option value='all'>List All</option>
              <option v-for='d in departments' :value="d">{{d}}</option>
          </select>

          <select class='home-ddl' v-model='centreSelection' @change="getMinistryRoles">
              <option disabled selected value='default'>Centres</option>
              <option value='all'>List All</option>
              <option value="Axis">Axis</option>
              <option value="NEC">North East</option>
              <option value="WEC">West</option>
          </select>
      </div>
      <h5 style="color:white; margin:-90px 0px 100px 40px;">Contribute Roles</h5>
    </div>
    <div class="row">
      <div v-show="ministryRoles.length === 0" style='color:white; margin:10px 0px 20px 100px;'><i>No ministry found</i></div>
      <div v-for="role in ministryRoles" style="width:40%;" class="ml-4">
        <div class="card" v-on:click="join(role)">
          <img v-bind:src="'images/'+role.avatar" class="card-img-top" alt="..." />
          <div class="card-body" style="text-align:left;">
            <h5 class="card-title mt-3 mb-1">
              <b>{{role.name}}</b>
            </h5>
            <p class="card-text">{{transform(role)}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "../commons/http.js";
export default {
  name: "Browse",
  props: {
    msg: String
  },
  data: function() {
    return {
      ministryRoles: [],
      host: http.host,
      departments:[],
      deptSelection:'default',
      centreSelection:'default'
    };
  },
  methods: {
    getMinistryRoles: async function() {

      let filter = '';
      if(this.deptSelection !== 'default' && this.deptSelection !== 'all'){
        filter = 'department='+this.deptSelection;
      }
      
      if(this.centreSelection !== 'default' && this.centreSelection !== 'all'){
        if(filter.length > 0){
          filter +='&';
        }  
        switch(this.centreSelection){
          case "Axis": filter += 'axisCentre=1'; break;
          case "NEC":filter += 'northEastCentre=1'; break;
          case "WEC":filter += 'westCentre=1';break;
        }
      }

      let url = '/ministryrole';
      if(filter.length > 0){
        filter = '?limit=999&'+filter;
        url += filter;
      }else{
        url += '&limit=999'
      }

      var response = await http.get(url);
      if (response.status == 200) {
        this.ministryRoles = response.data;
      }
      this.ministryRoles.forEach(function(role) {
        if (!role.avatar) {
          role.avatar = { id: 0 };
        }
      });
    },
    transform: function(r) {
      let text = "";
      if (r.axisCentre) {
        text += "Axis, ";
      }
      if (r.northEastCentre) {
        text += "NEC, ";
      }
      if (r.westCentre) {
        text += "WEC, ";
      }
      text += r.department;
      return text;
    },
    join: async function(role) {
      this.$router.push("/signup/" + role.id);
    },
    getDepartments: async function(){
      try{
        let response = await http.get('/ministryrole/dept');
        this.departments = response.data;
      }catch(err){
        console.error('dept err', err);
      }
    }
  },
  beforeMount: function() {
    if (!window.isMobileView()) {
      location.href = "#/";
    } else {
      this.getMinistryRoles();
      this.getDepartments();
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.browse {
  background-color: #1b2437;
}

.card-body {
  background-color: #1b2437;
  color: white;
  padding: 0px;
}

.card {
  border:0px;
  cursor: pointer;
}

.card-text {
  font-size: 80%;
}
.home-ddl-bar{
    background-color:black;
    width:100%;
    text-align:left;
    padding-left:50px;
}
.home-ddl{
    
    background-color:black;
    color:white;
    border-color:transparent;
    padding:7px;
}

.home-ddl:focus{
    background-color:white;
    color:black;
}
</style>